import { createAsyncThunk } from '@reduxjs/toolkit';
import { remove, post } from '../models/base';

export const deletePhoto = createAsyncThunk(
  'photo/deletePhoto',
  async (photoId, { rejectWithValue, getState }) => {
    const { album } = getState().album;
    const { folder } = getState().folders;

    try {
      const queryPath = `/albums/${album.id}/folders/${folder.id}/photos/${photoId}`;
      await remove(queryPath);
      return photoId;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);

export const uploadPhoto = createAsyncThunk(
  'photo/uploadPhoto',
  async (uploadedFileData, { rejectWithValue, getState }) => {
    const { album } = getState().album;
    const { folder } = getState().folders;

    try {
      const queryPath = `/albums/${album.id}/folders/${folder.id}/photos`;
      const response = await post(queryPath, uploadedFileData);
      return response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);
